export default __webpack_public_path__ + "static/media/arr.515c26c5.svg";